import { render } from "./AdminOrgStatuses.vue?vue&type=template&id=2b043146&scoped=true"
import script from "./AdminOrgStatuses.vue?vue&type=script&lang=js"
export * from "./AdminOrgStatuses.vue?vue&type=script&lang=js"

import "./AdminOrgStatuses.vue?vue&type=style&index=0&id=2b043146&scoped=true&lang=css"

import exportComponent from "C:\\Users\\GlavTV\\Documents\\GitHub\\octagon_uz\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b043146"]])

export default __exports__